import { StoreProjectAssigneeListItem } from "@/types/storeProjectAssignees";
import { Row } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";
import { PATH_PROJECT_WITH_ID } from "@/constants";

export const useStoreProjectAssigneeColumnOverrides = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      project_name: {
        id: "project_name",
        meta: {
          externalPath: (row: StoreProjectAssigneeListItem) =>
            generatePath(PATH_PROJECT_WITH_ID, { projectId: row.project_id }),
        },
      },
      is_primary: {
        id: "is_primary",
        cell: ({ row }: { row: Row<StoreProjectAssigneeListItem> }) => (
          <>
            {t(
              `storeProjectAssignees.enum.isPrimary.${row.original.is_primary}`,
            )}
          </>
        ),
      },
    }),
    [t],
  );
};
